var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{staticClass:"directory-form-input",attrs:{"placeholder":_vm.placeholder},on:{"click":_vm.selectFile},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }